import React, { useEffect } from 'react';
import './AboutUs.css';
import AboutImg from '../../Assets/AboutUs.png';
import quality from '../../Assets/quality.png';
import security from '../../Assets/security.png';
import setting from '../../Assets/setting.png';
import verfied from '../../Assets/verified.png';
import dept from '../../Assets/dept.png';
import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: 'easeOut' }
};

const slideLeft = {
    initial: { opacity: 0, x: -50 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.8, ease: 'easeOut' }
  };
  
  const slideRight = {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.8, ease: 'easeOut' }
  };





const AboutUs = () => {
    useEffect(() => {
        let currentSlide = 1;
        const totalSlides = 6;
    
        const interval = setInterval(() => {
          currentSlide = (currentSlide % totalSlides) + 1;
          const radio = document.getElementById(`slide-${currentSlide}`);
          if (radio) radio.checked = true;
        }, 4500);
    
        return () => clearInterval(interval); // Clean up on unmount
      }, []);
    return (
        <div className=' to-blue-100 aboutus' id='Aboutus'>
            <div className='flex justify-center gap-14 aboutus-part1'>
  <motion.div
    className='w-[30%]'
    initial="initial"
    whileInView="animate"
    viewport={{ once: true, amount: 0.3 }}
    variants={slideLeft}
  >
    <h1 className='abtHeading'>About Us</h1>
    <p>
      MELSHA is a premier consultancy firm specializing in company formation, business management, and corporate advisory services in the UAE and beyond. With 8 years of expertise, we offer tailored solutions to entrepreneurs, startups, and corporations, ensuring hassle-free business setup and seamless compliance with UAE regulations.
      <br />
      MELSHA Business Advisors will assist you to select the most effective and efficient legal entity best suitable for your commercial purpose, to form and register that entity in line with UAE laws and regulations and to ensure your day-to-day business operations are in compliance with the international corporate standards.
    </p>
  </motion.div>

  <motion.img
    src={AboutImg}
    className='abt-img'
    alt="About Us"
    initial="initial"
    whileInView="animate"
    viewport={{ once: true, amount: 0.6 }}
    variants={slideRight}
  />
</div>




          <div className='flex justify-center flex-col align-middle py-[50px] section'>
            <h1 className='choose-header'>Why Choose Melsha</h1>
            <div className='flex flex-row justify-center'>
                <div className='flex flex-col justify-center items-center'>
                    <div className='w-[60%] '>
                        <img src={quality} className='choose-icons'/>
                        <div className='choose-heading'>Expert Guidance</div>
                        <div className='choose-para'>End-to-end business setup solutions in UAE Mainland, Free Zones, and Offshore jurisdictions.</div>
                    </div>
                    <div className='w-[60%]'>
                        <img src={security}  className='choose-icons'/>
                        <div className='choose-heading'>Compliance & Legal Support</div>
                        <div className='choose-para'>Assistance with UAE corporate laws, visa processing, tax registration, and regulatory approvals.</div>
                    </div>
                </div>
                <div className='flex flex-col justify-center items-center'>
                    <div className='w-[60%]'>
                        <img src={setting} className='choose-icons' />
                        <div className='choose-heading'>Business Efficiency</div>
                        <div className='choose-para'>Streamlined licensing, renewal, and administrative support to ensure smooth operations.</div>
                    </div>
                    <div className='w-[60%]'>
                        <img src={verfied} className='choose-icons' />
                        <div className='choose-heading'>Transparent Pricing</div>
                        <div className='choose-para'>No hidden costs, with official government receipts provided.</div>
                    </div>

                </div>
            </div>
          </div>

        <section id='Service'>
            <h1 className='carousel-header'> Scope of Service</h1>
            <div class="container">
                <div class="carousel">
                    <input type="radio" name="slides" checked="checked" id="slide-1" />
                    <input type="radio" name="slides" id="slide-2"/>
                    <input type="radio" name="slides" id="slide-3"/>
                    <input type="radio" name="slides" id="slide-4"/>
                    <input type="radio" name="slides" id="slide-5"/>
                    <input type="radio" name="slides" id="slide-6"/>
                    <ul class="carousel__slides">
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                    <img src="https://www.1stformationsblog.co.uk/wp-content/uploads/2022/09/Shutterstock_2021639273.jpg" alt="" />
                                </div>
                                <figcaption>
                                    <h1>Annual Company Management</h1>
                                    <div className='description'>We provide efficient service for all the annual compliance and renewal of the Mainland company </div>
                                    <ul className="dotted-list">
                                        <li>License Renewal</li>
                                        <li>Approvals from Department of Culture & Tourism</li>
                                        <li>Lease Agreement Registration</li>
                                        <li>Establishment Card Renewal</li>
                                        <li>Labor Card Renewal</li>
                                        <li>Annual UBO Form Submission</li>
                                        <li>Annual ESR Declaration</li>
                                        <li>Updates for UAE Corporate Tax Laws</li>
                                        <li>Co-ordination with DED for any other requirements</li>
                                        <li>Legal Documents Submissions & Collection</li>
                                        
                                    </ul>
                                </figcaption>
                            </figure>
                        </li>
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                    <img src="https://infosconnect.com/wp-content/uploads/2020/02/visa-assistance.jpg" alt="" />
                                </div>
                                <figcaption>
                                <h1>Assistance For Visa Handling</h1>
                                    <div className='description'>We provide smooth and seamless Visa Handling Services for all the Employees and the Dependent Family members. </div>
                                    <ul className="dotted-list">
                                        <li>New Visa Applications & Renewals</li>
                                        <li>Visa Renewals</li>
                                        <li>Visa Cancellations</li>
                                        <li>Family Dependent Visa</li>
                                        <li>Golden Visa Application Service</li>

                                    </ul>                        
                                </figcaption>
                            </figure>
                        </li>
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                    <img src="https://irishbuildingmagazine.ie/wp-content/uploads/2021/05/Irish-building_PJ-Rudden-Skills-Gap_May_2021.jpg" alt="" />
                                </div>
                                <figcaption>
                                <h1>Other Labor Department Services</h1>
                                    <div className='description'>We offer comprehensive support for various labor-related processes to ensure full compliance with UAE labor laws. Our team handles documentation, submissions, and coordination with MOHRE and other government departments efficiently. </div>
                                    <ul className="dotted-list">
                                        <li>Labor Contract Amendment</li>
                                        <li>Labor Department File Updates</li>
                                        <li>E-Signature Card (adding new person)</li>
                                        <li>Work Permit Application for Relative</li>

                                    </ul>                          
                                </figcaption>
                            </figure>
                        </li>
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                    <img src="https://ifza.com/wp-content/uploads/2024/08/Immigration-Services-License.webp" alt="" />
                                </div>
                                <figcaption>
                                <h1>Other Immigration Department Services</h1>
                                    <div className='description'>  Our Immigration Department offers a variety of services to assist individuals, families, and businesses in navigating immigration processes. We ensure full compliance with national regulations and streamline your experience with timely, accurate assistance.
                                    </div>
                                    <ul className="dotted-list">
                                        <li>Establishment Card Renewal</li>
                                        <li>Entry / Exit Report</li>
                                        <li>UID Number Merging</li>

                                    </ul>                              
                                </figcaption>
                            </figure>
                        </li>
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                    <img src={dept} alt="" />
                                </div>
                                <figcaption>
                                <h1>Other Departments Renewal Services</h1>
                                    <div className='description'>  We offer comprehensive renewal services across various departments to ensure that your documentation remains up to date and in full compliance with local regulations. Our team efficiently handles renewals, submissions, and coordination with relevant authorities.
                                    </div>
                                    <ul className="dotted-list">
                                        <li>PO Box</li>
                                        <li>Chamber of Commerce</li>
                                        <li>Office Ejari</li>
                                    </ul>                           
                                </figcaption>
                            </figure>
                        </li>
                        <li class="carousel__slide">
                            <figure>
                                <div>
                                  <img src="https://cdn-icons-png.flaticon.com/512/3135/3135679.png" class="w-20 h-20" />

                                </div>
                                <figcaption>
                                <h1>Accounting & Taxation</h1>
                                    <div className='description'>  We provide expert accounting and taxation services to ensure compliance with local and international tax regulations. Our team offers customized solutions that streamline your financial processes, optimize tax planning, and support your business growth.
                                    </div>
                                    <ul className="dotted-list">
                                        <li>Corporate Tax servicess</li>
                                        <li>Accounting and book keeping</li>
                                        <li>VAT registration Services</li>
                                        <li>VAT return services</li>

                                    </ul>                           
                                </figcaption>
                            </figure>
                        </li>
                    </ul>    
                    <ul class="carousel__thumbnails">
                        <li>
                            <label for="slide-1"><img src="https://www.1stformationsblog.co.uk/wp-content/uploads/2022/09/Shutterstock_2021639273.jpg" className='carousel-thumb' alt="" /></label>
                            <div className='overlay'>
                                <span class="center-text">1</span>
                            </div>
                        </li>
                        <li>
                            <label for="slide-2"><img src="https://infosconnect.com/wp-content/uploads/2020/02/visa-assistance.jpg" className='carousel-thumb' alt="" /></label>
                            <div className='overlay'>
                                <span class="center-text">2</span>
                            </div>
                        </li>
                        <li>
                            <label for="slide-3"><img src="https://irishbuildingmagazine.ie/wp-content/uploads/2021/05/Irish-building_PJ-Rudden-Skills-Gap_May_2021.jpg"  className='carousel-thumb'alt="" /></label>
                            <div className='overlay'>
                                <span class="center-text">3</span>
                            </div>
                        </li>
                        <li>
                            <label for="slide-4"><img src="https://ifza.com/wp-content/uploads/2024/08/Immigration-Services-License.webp" className='carousel-thumb' alt="" /></label>
                            <div className='overlay'>
                                <span class="center-text">4</span>
                            </div>
                        </li>
                        <li>
                            <label for="slide-5"><img src={dept} alt="" className='carousel-thumb'/></label>
                            <div className='overlay'>
                                <span class="center-text">5</span>
                            </div>
                        </li>
                        <li>
                            <label for="slide-6"><img src="https://cdn-icons-png.flaticon.com/512/3135/3135679.png" className='carousel-thumb' alt="" /></label>
                            <div className='overlay'>
                                <span class="center-text">6</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

          
        </div>

    )}


export default AboutUs;